import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';

import KbHelpPanel from './components/KbHelpPanel/KbHelpPanel.vue';
import KbArticleView from './views/KbArticleView.vue';
import KbHelpView from './views/KbHelpView.vue';
import KbSectionView from './views/KbSectionView.vue';

// The panel is registered top-level rather than per-route because it opens over whatever
// screen the user is already on, driven by the `kb` query parameter alone.
export const kbModule = createModuleBuilder()
    .demandContext<{ gatewayClient: GatewayApiClient }>()
    // The tenant is optional so one generic link -- `#/help/a/<id>`, the kind a product-update
    // newsletter sends to every customer -- works for all of them: the auth guard treats any
    // `/:rpId?/` route as user-only, sends a signed-out reader through login and back, and fills
    // in a signed-in reader's preferred client, exactly as it does for `/:rpId?/dashboard`.
    .registerRoutes(() => [
        {
            path: '/:rpId?/help',
            name: 'kbHelp',
            component: KbHelpView as any,
            meta: { title: 'Help', whiteBackground: true },
        },
        {
            path: '/:rpId?/help/s/:sectionId',
            name: 'kbSection',
            component: KbSectionView as any,
            meta: { title: 'Help', whiteBackground: true },
        },
        {
            path: '/:rpId?/help/a/:articleId/:slug?',
            name: 'kbArticle',
            component: KbArticleView as any,
            meta: { title: 'Help', whiteBackground: true },
        },
    ])
    .registerTopLevelComponent(KbHelpPanel)
    .end();
